module.exports = "/dist/assets/images/minus.svg";